"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const nanoid_1 = require("nanoid");
const defaultElementAnimation_1 = __importDefault(require("./defaultElementAnimation"));
const element_1 = require("../types/element");
function defaultTextElement() {
    return {
        active: false,
        angle: 0,
        animationsTimeline: [(0, defaultElementAnimation_1.default)()],
        background: '#9dcc82',
        backgroundType: 'color',
        borderRadius: '0',
        dynamic: false,
        dynamicField: '',
        editable: false,
        height: 84,
        html: 'WRITE YOUR TEXT HERE',
        id: (0, nanoid_1.nanoid)(8),
        isNew: true,
        lock: false,
        opacity: 100,
        outline: 0,
        playing: false,
        previewing: false,
        setMethod: 'setText',
        shadow: {
            blur: 0,
            color: '#000000',
            x: 0,
            y: 0,
        },
        textStyles: {
            alignment: 'left',
            backgroundColor: '#ffffff00',
            color: '#000000',
            fontFamily: 'Roboto',
            // @ts-expect-error
            fontSize: 72,
            fontStyle: 'normal', // italic
            fontWeight: 'normal', // bold
            letterSpacing: 0,
            lineHeight: 84,
            textDecoration: 'none', // underline
        },
        textType: 0,
        type: element_1.ELEMENT_TYPE.TEXT,
        visible: true,
        width: 900,
        x: 80,
        y: 80,
    };
}
exports.default = defaultTextElement;
